var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHimsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2226 15.7736L6.91099 10.4658C6.62478 10.1798 6.23659 10.0191 5.83183 10.0191C5.42706 10.0191 5.03888 10.1798 4.75267 10.4658C4.46646 10.7518 4.30566 11.1397 4.30566 11.5442C4.30566 11.7445 4.34514 11.9428 4.42184 12.1278C4.49853 12.3129 4.61095 12.481 4.75267 12.6226L11.1511 19.0165C11.7481 19.613 12.7124 19.613 13.3094 19.0165L29.5045 2.83296C29.7907 2.54695 29.9515 2.15904 29.9515 1.75457C29.9515 1.35009 29.7907 0.962183 29.5045 0.676176C29.2183 0.390169 28.8301 0.229492 28.4253 0.229492C28.0206 0.229492 27.6324 0.390169 27.3462 0.676176L12.2226 15.7736Z",
    fill: "#00A82E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0066,
    cy: 12.5944,
    r: 11.9579,
    stroke: "#00A82E",
    strokeWidth: 0.814153
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHimsCheck);
export default __webpack_public_path__ + "static/media/hims_check.a1dfa51e260a5b61808bf32cd3b01a2b.svg";
export { ForwardRef as ReactComponent };